import * as types from './type';

import { Product }  from  '../../services/product';

export function getProducts() {
    return {
      type: types.GET_PRODUCTS,
      payload: Product.getProducts(),
    };
};